import * as React from 'react';
import * as styles from './HubImage.css';
import { IconActionPlus24 } from '@cian/ui-kit-design-tokens/icons';

interface IHubImageProps {
  url?: string;
}

export const HubImage: React.FC<IHubImageProps> = ({ url }) => {
  return (
    <div className={styles['container']}>
      {url ? (
        <img src={url} className={styles['image']}></img>
      ) : (
        <div className={styles['placeholder']}>
          <IconActionPlus24 color="icon-secondary-disabled" />
        </div>
      )}
    </div>
  );
};
